import React from 'react'
import useIsOfficeAddin from '../../utils/use-is-office-addin'
import { HeaderTabs } from '../header-tabs'
import { LoginSignup } from '../login-signup'
import { Logo } from '../logo'
import { ThemeSwitch } from '../theme-switch'
import s from './header.module.css'

export const Header: React.FC = () => {
  const isPowerPoint = useIsOfficeAddin();

  return <div className={s.header}>
    {
      isPowerPoint
        ? <HeaderTabs />
        : <><Logo />
          <div className={s.right}>
            <ThemeSwitch />
            <LoginSignup />
          </div>
        </>
    }
  </div>
}

